/**
 * The status of an asset is indexed in the state by a combination of the
 * assetId, assetType and whether this is a preload or not.
 */
export const keyForAsset = (assetId, assetType, preload) =>
    assetId + '-' + assetType + '-' + (preload ? 'preload' : 'load');
